"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToMilliseconds = exports.nowInMilliseconds = exports.currentEpoch = void 0;
const currentEpoch = () => Math.floor(new Date().getTime());
exports.currentEpoch = currentEpoch;
const nowInMilliseconds = () => Math.floor(new Date().getTime());
exports.nowInMilliseconds = nowInMilliseconds;
const convertToMilliseconds = (time) => {
    return time < 1e12 ? time * 1000 : time;
};
exports.convertToMilliseconds = convertToMilliseconds;
